import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

import { Card } from "../Card";
import { Spinner } from "../Spinner";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  text?: string;
};

const PostLoader = ({
  isOpen,
  onClose,
  text = "Loading your account",
}: Props) => (
  <Transition.Root show={isOpen} as={Fragment}>
    <Dialog
      as="div"
      className="fixed z-50 inset-0 overflow-y-auto"
      onClose={onClose}
    >
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enterTo="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            className={`
              relative 
            inline-block 
            overflow-hidden 
            transform 
            transition-all s
            align-middle 
            sm:max-w-sm sm:w-full 
            `}
          >
            <Card
              size="small"
              theme="light"
              onClose={onClose}
              showCloseButton={false}
            >
              <div className="flex items-center flex-col">
                <p className="text-xl leading-xl mb-5 mx-auto text-center font-bold">
                  {text}
                </p>
                <Spinner theme="light" isBig />
              </div>
            </Card>
          </div>
        </Transition.Child>
      </div>
    </Dialog>
  </Transition.Root>
);

export { PostLoader };
